
import React, { useState, useEffect, useContext } from "react";


import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import { useNavigate, useLocation,useParams } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";

import SweetAlert from 'react-bootstrap-sweetalert';
import * as Config from "../constants/Config";
import Loader from "../components/loader";
import { contentContext } from "../context/contentContext";
import SessionPopup from "../pages/SessionPopup"
import TableLoader from "../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

let { lambda, appname } = window.app

const ReadNotification = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");
    let { id } = useParams();
    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    console.log("Iddddddddddddddddddddddd",id)
    const [perpage, setPerpage] = useState(10);
    const[readData,setReadData]=useState({})
   // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
const[image,setImg]=useState('')
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum]= useState();
    // const [sortDirection, setSortDirection] = useState('asc');
         

     

    // let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const {searchedFlag, setSearchedFlag,  isLoading, setIsLoading,userData,notifications, setNotifications, setUserData,GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch ,currentPage, setcurrentPage, data, setData,rowsPerPage, setRowsPerPage,currentPageNew, setCurrentPage,route, setRoute,usePrevious, setActiveMenuId,  GetTimeActivity} = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu==="User Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
     useEffect(() => {
         if(prevRoute !== undefined && prevRoute!=route){
             setCurrentPage(1)
             setRowsPerPage(15)
             setSearchedFlag(false);
             setUserSearch("")
         }
     }, [prevRoute]);

     useEffect(()=>{
        readNotification()
       
     },[id])

     useEffect(() => {

       if (window.site === undefined) {
           setTimeout(() => {
               if (window.site && window.site.common && window.site.common.imageCloudfront) {
                   setImg(window.site.common.imageCloudfront)
               }
           }, 1000);
       }
       if (window.site && window.site.common && window.site.common.imageCloudfront) {
           setImg(window.site.common.imageCloudfront)
       }
   
   
   }, [window.site]);


    //  console.log('prevRoute--->',prevRoute)
    //  console.log('currentRoute--->',route)
    const keyForRerender = `${rowsPerPage}_${data?.length}`;
     const columns = [
 
         {
             name: 'Name',
             selector: row => row?.name ?? "",
             sortable: true,
         },
         {
             name: 'User Type',
             selector: row => row?.type ?? "",
             sortable: true,
         },
         {
             name: 'Email id',
             selector: row => row?.emailid ?? "",
             sortable: true,
         },
         {
             name: 'Phone Number',
             selector: row => row?.phone ?? "",
             sortable: true,
         },
         {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
        },
        
 
         {
             name: <>{(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 'Actions' : null}</>,
             cell: (props) => 
            //   {
                subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
            <div className="d-flex">
            {subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
                <a onClick={e => handleViewUser(e, props.userid)}
                    className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}><i
                        className="mdi mdi-eye font-size-18"></i></a>}
            {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true && <>
                {props.userid === id ? <a
                    className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i
                        className="mdi mdi-pencil font-size-18"></i></a> : <a onClick={e => handleEditUser(e, props.userid)}
                            className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i
                                className="mdi mdi-pencil font-size-18"></i></a>}</>}
        </div>
            //  }
             ,
             ignoreRowClick: true,
             allowOverflow: true,
             button: true,
         },
     ];
 
     const handlePageChange = (page) => {
        GetTimeActivity()   
         setCurrentPage(page);
       };
     
       const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()   
         setRowsPerPage(newPerPage);
       };
     
// console.log('datattatatattatat',data)
    useEffect(() => {
        setRoute("user")
       //  GetClientDataContext()
        setActiveMenuId(200000)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management":false,
            "Reports": false
        })
        userActivity();
        setActiveMenuId('')
    }, []);
    
    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "clientid": localStorage.getItem("clientid"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


   const previousId = localStorage.getItem("previousid");
const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }

 

    // useEffect(() => {
    //     if (!localStorage.getItem("token")) {
    //         navigate("/");
    //     }
      
    // }, []);

   //  useEffect(() => {
      

   //      console.log("trueeeeeeeeee",searchedFlag);
   //      if (searchedFlag) { 
   //          console.log("came") 
   //          handleSearch();
   //      } else {
   //          console.log("called get all deals") 
   //          User();
   //      }

   //  }, [searchedFlag]);




    const User = (e) => {
        GetTimeActivity()   
        setIsLoading(true)
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/users?appname=' + appname + "&token=" + token,
        })
            .then(function (response) {
                console.log("response", response);
                if (response?.data?.result==="Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                setUser(response?.data?.result);
                setData(response?.data?.result?.data);
                global.exportExcelData = response?.data?.result?.data
                      


                setIsLoading(false);
                setUserSearch("");
                setSearchedFlag(false);
                }
            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }



  

    const getNotifications = async () => {
        GetTimeActivity(); // Assuming this is necessary

        try {
            const response = await tmdbApi.getNotifications();

            // if (response?.result?.length > 0) {

                setNotifications(response?.result)
                setIsLoading(false)
                // Make sure you're updating the context state properly

            // }
      
        } catch (error) {
            console.error("Error fetching client info:", error);
            setIsLoading(false)
        }
    };
    
  

    const readNotification = async () => {
        setIsLoading(true)
        // console.log("idddddddddddddddddddddddddddd",Id)
        GetTimeActivity(); // Assuming this is necessary

        try {
            const response = await tmdbApi.readNotification({notificationid:id});

            if (response?.result?.length > 0) {
                setReadData(response?.result[0])
                console.log("readResponseeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",response?.result[0])
                getNotifications()
                // setNotifications(response?.result)
                // Make sure you're updating the context state properly

            }
        } catch (error) {
            console.error("Error fetching client info:", error);
        }
    };

   //  const handleKeypress = (e) => {
   //      //it triggers by pressing the enter key
   //      GetTimeActivity()   
   //      if ((e.key === "Enter")) {
   //          setTimeout(function () {
   //              handleSearch();
   //          }, 1000);
   //      }
   //  };
 
    const handleEditUser = (e, paramuserid) => {
        console.log('paramuserid',paramuserid)
        GetTimeActivity()   
        navigate("/edituser/" + paramuserid);
    }
    const handleViewUser = (e, paramuserid) => {
        GetTimeActivity()   
        console.log('paramuserid',paramuserid)

        navigate("/viewuser/" + paramuserid);
    }

    function formatTimeAgo(dateString) {
        const now = new Date();
        const created = new Date(dateString);
        const diffInSeconds = Math.floor((now - created) / 1000);
      
        if (diffInSeconds < 60) return 'Just now';
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
        const diffInDays = Math.floor(diffInHours / 24);
        return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
      }

        function exportToExcel(jsonData, fileName) {
            delete jsonData['_id'];
            const worksheet = XLSX.utils.json_to_sheet(jsonData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
            //FileSaver.saveAs(data, `${fileName}.xlsx`);
            FileSaver.saveAs(data1, `UsersData.xlsx`);
            console.log('data22222--->',data)
        }
        const customSort = (rows, selector, direction) => {
            const sortedData = rows.slice().sort((rowA, rowB) => {
              // use the selector function to resolve your field names by passing the sort comparators
              // const aField = selector(rowA);
        const aField = String(selector(rowA)).toLowerCase();

              //  const bField = selector(rowB);
          const bField = String(selector(rowB)).toLowerCase();
          
              let comparison = 0;
          
              if (aField > bField) {
                comparison = 1;
              } else if (aField < bField) {
                comparison = -1;
              }
          
              return direction === 'desc' ? comparison * -1 : comparison;
            });
          
            // Log the sorted data to the console
            // setSortedRecomData(sortedData)
            global.exportExcelData = sortedData
            // console.log('Sorted Data------>:', sortedData);
          
            return sortedData;
          };    
    // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                {/* Start right Content here  */}
              {isLoading?<Loader/>:
                    <div className="main-content user-management">

                    <div className="page-content">
                      <div className="container-fluid">
                  
                        <div className="row breadcrumb">
                          <div className="col-lg-12">
                            <div className="d-flex align-items-center">
                  
                              <div className="flex-grow-1">
                                <h4 className="mb-2 card-title">NOTIFICATIONS</h4>
                              </div>
                  
                            </div>
                          </div>
                        </div>
                  
                        <div className="row table-data">
                          <div className="col-12">
                            <div className="card">
                              <div className="card-body">
                                <div className="notification-view">
                  
                                  <div
                                    className="notification-item store_block unread"
                                    id={`readnotification-${readData?._id || 'default'}`}
                                  >
                                    <div className="flex-grow-1">
                                      <div className="top-heading">
                                        <p className="mb-1"><strong>{readData?.title}</strong></p>
                                        <small className="text-muted">{readData?.created && formatTimeAgo(readData.created)}</small>
                                      </div>
                                      <p className="mb-1 text-muted">{readData?.description}</p>
                                    </div>
                                  </div>
                  
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                  
                      </div>
                    </div>
                  
                    <SweetAlert
                      show={tableErrMsg}
                      custom
                      confirmBtnText="ok"
                      confirmBtnBsStyle="primary"
                      title={"Something went wrong. Please reload again."}
                      onConfirm={() => setTableErrMsg(false)}
                    />
                  
                    <Footer />
                  
                  </div>
                  }
             


            </div>
        </>
    );
};

export default ReadNotification;
